import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { SessionTimeoutComponent } from './layout/session-timeout/session-timeout.component';

@Component({
  selector: 'investigator-root',
  standalone: true,
  imports: [RouterOutlet, SessionTimeoutComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent {}
